(function () {
  'use strict';

  /**
   * @param {() => void} callback
   * @param {number} [maxAttempts]
   */
  function whenCalendlyReady(callback, maxAttempts) {
    var attempts = 0;
    var limit = typeof maxAttempts === 'number' ? maxAttempts : 50;

    (function poll() {
      if (
        window.Calendly &&
        typeof window.Calendly.initPopupWidget === 'function'
      ) {
        callback();
        return;
      }

      if (attempts < limit) {
        attempts += 1;
        window.setTimeout(poll, 100);
      }
    })();
  }

  /**
   * @param {string} url
   */
  function openCalendlyPopup(url) {
    if (!url || typeof url !== 'string') return;

    var trimmed = url.trim();
    if (!trimmed) return;

    whenCalendlyReady(function () {
      window.Calendly.initPopupWidget({ url: trimmed });
    });
  }

  window.HakeemOpenCalendlyPopup = openCalendlyPopup;

  function resolveCalendlyUrl(btn) {
    var direct = btn.getAttribute('data-calendly-url');
    if (direct && direct.trim()) return direct.trim();

    var host = btn.closest('[data-calendly-url]');
    if (host) {
      var inherited = host.getAttribute('data-calendly-url');
      if (inherited && inherited.trim()) return inherited.trim();
    }

    return '';
  }

  function initCalendlyButtons() {
    document.querySelectorAll('[data-open-calendly]').forEach(function (btn) {
      if (btn.getAttribute('data-calendly-bound') === 'true') return;
      btn.setAttribute('data-calendly-bound', 'true');

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openCalendlyPopup(resolveCalendlyUrl(btn));
      });
    });

    var section = document.getElementById('book-meeting');
    if (section) {
      var sectionUrl = section.getAttribute('data-calendly-url') || '';
      window.HakeemOpenCalendly = function () {
        openCalendlyPopup(sectionUrl);
      };

      var hash = (window.location.hash || '').toLowerCase();
      var fromQuoteRedirect = sessionStorage.getItem('hakeem_quote_pending_booking');
      if (
        !fromQuoteRedirect &&
        (hash === '#schedule' || hash === '#bookx') &&
        sectionUrl
      ) {
        openCalendlyPopup(sectionUrl);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalendlyButtons);
  } else {
    initCalendlyButtons();
  }
})();
